import React from 'react'
import MainCart from "../Components/CartPage/CartMain"
import Header from '../Components/HomePage/Header'

const Cart = () => {
  return (
    <React.Fragment>
      <Header />
      <MainCart />
    </React.Fragment>
  )
}

export default Cart